(() => {
  const finishLabel = value => ({Gold:'18K Gold-Plated',Silver:'Silver Stainless Steel','Rose Gold':'18K Rose-Gold-Plated'})[value] || value;
  function init(root) {
    if (root.dataset.mpnPreviewReady) return;
    root.dataset.mpnPreviewReady = 'true';
    const finish = root.querySelector('[data-mpn-preview-finish]');
    const engraving = root.querySelector('[data-mpn-preview-engraving]');
    const name = root.querySelector('[data-mpn-preview-name]');
    const back = root.querySelector('[data-mpn-preview-back]');
    const photo = root.querySelector('[data-mpn-preview-photo]');
    const image = root.querySelector('[data-mpn-preview-image]');
    const error = root.querySelector('[data-mpn-preview-error]');
    let objectUrl = null;
    let version = 0;
    function update() {
      const hasBack = engraving.value === 'back';
      back.hidden = !hasBack;
      back.querySelector('input').disabled = !hasBack;
      const price = engraving.selectedOptions[0].dataset.price;
      root.querySelector('[data-mpn-preview-price]').textContent = price;
      root.querySelector('[data-mpn-preview-summary]').textContent = [finishLabel(finish.value), hasBack ? 'portrait + name + back message' : 'portrait + name', name.value.trim() ? `for ${name.value.trim()}` : '', price].filter(Boolean).join(' · ');
    }
    finish.addEventListener('change', () => {
      update();
      const thumbnails = [...root.querySelectorAll('[data-lf-gallery-src]')];
      const current = thumbnails.find(button => button.getAttribute('aria-pressed') === 'true');
      // Keep the shopper's chosen view when it already shows the selected finish.
      if (current?.dataset.lfGalleryFinish === finish.value) return;
      const matching = thumbnails.find(button => button.dataset.lfGalleryFinish === finish.value);
      // Reuse the gallery interaction so captions, zoom and responsive src stay in sync.
      matching?.click();
    });
    engraving.addEventListener('change', update);
    name.addEventListener('input', update);
    update();
    function clear() {
      version++;
      photo.value = '';
      image.hidden = true;
      image.querySelector('img').removeAttribute('src');
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      objectUrl = null;
    }
    root.querySelector('[data-mpn-preview-remove]').addEventListener('click', () => { clear(); error.textContent = ''; });
    photo.addEventListener('change', async () => {
      const ticket = ++version;
      image.hidden = true;
      error.textContent = '';
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      objectUrl = null;
      const file = photo.files[0];
      if (!file) return;
      if (!['image/jpeg', 'image/png'].includes(file.type) || !/\.(jpe?g|png)$/i.test(file.name) || !file.size || file.size > 10 * 1024 * 1024) {
        clear();
        error.textContent = 'Choose a JPG or PNG photo, up to 10 MB.';
        return;
      }
      const candidate = URL.createObjectURL(file);
      const probe = new Image();
      probe.src = candidate;
      try {
        await probe.decode();
        if (ticket !== version || !root.isConnected) { URL.revokeObjectURL(candidate); return; }
        objectUrl = candidate;
        image.querySelector('img').src = candidate;
        image.hidden = false;
      } catch {
        URL.revokeObjectURL(candidate);
        if (ticket === version) { clear(); error.textContent = 'This photo could not be opened. Please choose another.'; }
      }
    });
    const unload = event => {
      if (!event.target.contains(root)) return;
      clear();
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
  }
  document.querySelectorAll('[data-mpn-design-preview]').forEach(init);
  if (!window.mpnPreviewSectionListener) {
    window.mpnPreviewSectionListener = true;
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-mpn-design-preview]').forEach(init));
  }
})();
